import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function FAQ() {
  const { t } = useTranslation('toiture');
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal<HTMLDivElement>(0.15);
  const { ref: listRef, isVisible: listVisible } = useScrollReveal<HTMLDivElement>(0.1);
  const [openId, setOpenId] = useState<number | null>(null);

  const faqData = [
    { id: 1, q: 'faq_q1', a: 'faq_a1' },
    { id: 2, q: 'faq_q2', a: 'faq_a2' },
    { id: 3, q: 'faq_q3', a: 'faq_a3' },
    { id: 4, q: 'faq_q4', a: 'faq_a4' },
    { id: 5, q: 'faq_q5', a: 'faq_a5' },
  ];

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="bg-soft-gray py-20 md:py-28 lg:py-32">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={titleRef}
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('faq_h2')}
          </h2>
        </div>

        <div
          ref={listRef}
          className={`space-y-3 transition-all duration-1000 delay-200 ${
            listVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="font-manrope font-semibold text-slate-primary text-sm md:text-base pr-4">
                  {t(faq.q)}
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-soft-gray shrink-0 transition-colors">
                  <i
                    className={`ri-arrow-down-s-line text-slate-primary transition-transform duration-300 ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-gray-500 text-sm md:text-base leading-relaxed">
                    {t(faq.a)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}